<!--做题报告-->
<template>
  <div class="content">
    <div class="top-bj"></div>
    <div class="main-box">
      <div class="top-line"></div>
      <div class="content-box">
        <div class="title">
          <div class="left">
            <h2 v-html="data.title"></h2>
            <p>感谢您的作答</p>
          </div>
          <div class="right">
            <i-circle
                :trail-width="5"
                :stroke-width="5"
                :percent="myResult.score"
                stroke-linecap="square"
                trail-color="#E5E5E5"
                stroke-color="#1a4bff">
              <div class="demo-i-circle-custom">
                <h1>{{ myResult.score }}分</h1>
                <p>考试得分</p>
              </div>
            </i-circle>
          </div>
        </div>
        <div class="h3">{{($route.query.id==887 || $route.query.id==877)?'参考答案':'考题解析'}}</div>
        <div class="answer-content">
          <div class="answer-box" v-for="(item,index) in data.question">
            <t-radio class="analysis-b" :question="item" :number="index+1" :isAnalysis="true"
                     v-if="item.subtype==='单选题'"></t-radio>
            <t-check class="analysis-b" :question="item" :number="index+1" :isAnalysis="true"
                     v-if="item.subtype==='多选题'"></t-check>
            <t-input class="analysis-b" :question="item" :number="index+1" :isAnalysis="true"
                     v-if="item.subtype==='填空题'"></t-input>
            <t-text-area class="analysis-b" :question="item" :number="index+1" :isAnalysis="true"
                         v-if="item.subtype==='简答题'"></t-text-area>
            <t-pan-duan class="analysis-b" :question="item" :number="index+1" :isAnalysis="true"
                        v-if="item.subtype==='判断题'"></t-pan-duan>
          </div>
        </div>
      </div>
      <div class="answerAgain">
        <Button type="primary" @click="answerAgain">再次答题</Button>
      </div>
    </div>
  </div>
</template>

<script>
import {getAnalysis} from "../../api/Interface";
import TTextArea from "../../components/topicType/tTextArea";
import TInput from "../../components/topicType/tInput";
import TPanDuan from "../../components/topicType/tPanDuan";
import TCheck from "../../components/topicType/tCheck";
import TRadio from "../../components/topicType/tRadio";

export default {
  name: "analysis",
  components: {TTextArea, TInput, TPanDuan, TCheck, TRadio},
  data() {
    return {
      data: {},
      myResult: {}
    }
  },
  mounted() {
    this.getAnalysisData()
  },
  methods: {
    getAnalysisData() {
      getAnalysis(this.$store.state.userInfoId).then(res => {
        if (res.state) {
          this.data = res.data
          this.myResult = res.my_result
        }
      }).catch(error => {
        console.log(error);
      })
    },
    answerAgain() {
      this.$router.push('/explain?id=' + this.$route.query.id)
    }
  }
}
</script>

<style lang="scss">
.optionImg {
  width: 160px;
  height: 90px;

  img {
    height: 100%;
  }
}

.question-item-title {
  font-size: 16px;
  color: #000;
  margin-bottom: 15px;
  line-height: 30px;

  .q-title {
    p {
      display: contents;
    }
  }
}

.ivu-notice {
  top: 40% !important;
}
</style>

<style lang="scss" scoped>
.content {
  .top-bj {
    width: 100%;
    height: 130px;
    background: url("../../assets/images/top_bj.png") no-repeat top;
    background-size: 100% 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
  }

  .main-box {
    height: calc(100% - 45px);
    background-color: #fcfcfc;
    position: absolute;
    top: 45px;
    left: 0;
    right: 0;
    bottom: 0;

    .top-line {
      height: 20px;
      background: #1a4bff;
      border: 4px solid #256eff;
      border-radius: 11px;
      box-shadow: 0 3px 6px 0 rgba(0, 53, 157, 0.62);
      margin: 10px 10px 0 10px;
      position: relative;
      z-index: 999;
    }

    .content-box {
      position: absolute;
      top: 8px;
      left: 5px;
      right: 5px;
      bottom: 0;
      z-index: 9999;
      margin: 13px 15px 0 15px;
      background-color: #fff;
      box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.1);
      padding: 0 14px;
      overflow-y: auto;
      height:calc(75vh - 52px);

      .title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 32px;
        //height: 80px;
        padding: 0 20px 25px 10px;
        border-bottom: 1px dashed #e8eaec;

        .left {
          line-height: 35px;

          h2 {
            font-size: 18px;
            color: #303133;
            font-weight: 600;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            padding-right: 10px;
            width: calc(100vw - 170px);
          }

          p {
            font-size: 14px;
            color: #797979;
          }
        }

        .right {
          width: 80px;
          height: 80px;

          /deep/ .ivu-chart-circle {
            width: 80px !important;
            height: 80px !important;
          }

          .demo-i-circle-custom {
            line-height: 22px;

            h1 {
              font-size: 18px;
              color: #3760f4;
              font-weight: 500;
            }

            p {
              font-size: 12px;
              color: #797979;
            }
          }
        }
      }

      .h3 {
        font-size: 18px;
        color: #303133;
        font-weight: bold;
        margin-top: 25px;
        position: relative;
        padding: 0 20px;

        &:before {
          content: "";
          display: block;
          width: 3px;
          height: 20px;
          background-color: #1a4bff;
          position: absolute;
          left: 0;
          top: 2px;
        }
      }

      .answer-content {
        //height: calc(100% - 210px);
        //overflow-y: auto;
        padding: 20px 20px;

        .analysis-b {
          margin-bottom: 26px;
        }
      }
    }
    .answerAgain{
      position: absolute;
      left: 26px;
      top: 75vh;
    }
  }
}
</style>
